import React, { useEffect } from "react";
import { Box, Typography, Paper } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useLocation } from "react-router-dom";

const SuccessfullyPlaceOrder = () => {
  const location = useLocation();
  const { stData } = location.state || {};
  
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)"
      py={4}
    >
      <Paper
        elevation={0}
        sx={{
          p: 5,
          textAlign: "center",
          borderRadius: "16px",
          backgroundColor: "#ffffff",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.08)",
          maxWidth: "500px",
          width: "100%",
          border: "1px solid rgba(76, 175, 80, 0.1)",
          animation: "slideUp 0.6s ease-out",
          "@keyframes slideUp": {
            from: {
              opacity: 0,
              transform: "translateY(20px)",
            },
            to: {
              opacity: 1,
              transform: "translateY(0)",
            },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 3,
            animation: "scaleIn 0.6s ease-out 0.2s backwards",
            "@keyframes scaleIn": {
              from: {
                opacity: 0,
                transform: "scale(0.8)",
              },
              to: {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          }}
        >
          <CheckCircleOutlineIcon
            sx={{
              fontSize: 100,
              color: "#4caf50",
              filter: "drop-shadow(0 8px 16px rgba(76, 175, 80, 0.25))",
            }}
          />
        </Box>
        
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            color: "#1a1a1a",
            mb: 1,
            letterSpacing: "-0.5px",
          }}
        >
          Order Confirmed
        </Typography>
        
        <Box
          sx={{
            height: "3px",
            width: "60px",
            background: "linear-gradient(90deg, #4caf50, #45a049)",
            borderRadius: "2px",
            mx: "auto",
            mb: 3,
          }}
        />
        
        <Typography
          variant="body1"
          sx={{
            color: "#666",
            mb: 2.5,
            fontSize: "1rem",
            lineHeight: 1.6,
          }}
        >
          Thank you for your purchase. We are now processing your order.
        </Typography>
        
        {/* <Typography
          variant="body1"
          sx={{
            color: "#666",
            mb: 3,
            fontSize: "0.95rem",
          }}
        >
          You'll receive a confirmation email shortly with tracking information.
        </Typography> */}

        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            border: "1px solid #e8e8e8",
            borderRadius: "12px",
            p: 2.5,
            mt: 3,
          }}
        >
          <Typography variant="caption" sx={{ color: "#999", display: "block", mb: 0.5 }}>
            Order Number
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
              fontSize: "1.1rem",
              color: "#4caf50",
              fontFamily: "monospace",
              letterSpacing: "1px",
            }}
          >
            {stData?.order?.orderNo || "---"}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default SuccessfullyPlaceOrder;